export interface TranslationEditor {
    /**
     * 编辑原文
     * @description 编辑原文, “正在编辑的译文”和“正在编辑的原文”会取消编辑状态
     * @param idx 原文索引
     * @returns 取消编辑的函数
     */
    editOriginal(idx: number): () => void;
    /**
     * 编辑译文
     * @description 编辑译文, “正在编辑的原文”和“正在编辑的译文”会取消编辑状态
     * @param idx 译文索引
     * @returns 取消编辑的函数
     */
    editTranslation(idx: number): () => void;
}

export const TranslationEditor = Symbol('TranslationEditor');

